/**
 * Google Analytics Controller
 * Manages Google Analytics initialization and consent
 */
const GA_MEASUREMENT_ID = 'G-ETEFDCJYVH';

/**
 * Initialize Google Analytics if consent is given
 * @param {boolean} analyticsAllowed - Whether analytics cookies are allowed
 */
export const initializeGoogleAnalytics = (analyticsAllowed) => {
  if (!analyticsAllowed) {
    disableGoogleAnalytics();
    return;
  }

  // Check if gtag is already loaded
  if (window.gtag) {
    // Already initialized, just update consent
    window.gtag('consent', 'update', {
      analytics_storage: 'granted',
    });
    return;
  }

  // Load Google Analytics script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(...args) {
    window.dataLayer.push(args);
  }
  window.gtag = gtag;

  // Configure Google Analytics with consent
  gtag('js', new Date());
  gtag('consent', 'default', {
    analytics_storage: 'granted',
  });
  gtag('config', GA_MEASUREMENT_ID, {
    anonymize_ip: true, // Privacy-friendly
  });
};

/**
 * Disable Google Analytics
 * Clears data and revokes consent
 */
export const disableGoogleAnalytics = () => {
  if (window.gtag) {
    // Revoke consent
    window.gtag('consent', 'update', {
      analytics_storage: 'denied',
    });
    
    // Clear existing data
    if (window.dataLayer) {
      window.dataLayer = [];
    }
  }

  // Remove GA scripts
  const scripts = document.querySelectorAll(
    `script[src*="googletagmanager.com/gtag/js"]`
  );
  scripts.forEach((script) => script.remove());
};

/**
 * Update Google Analytics consent based on preferences
 * @param {boolean} analyticsAllowed - Whether analytics cookies are allowed
 */
export const updateGoogleAnalyticsConsent = (analyticsAllowed) => {
  if (analyticsAllowed) {
    if (!window.gtag) {
      // Initialize if not already done
      initializeGoogleAnalytics(true);
    } else {
      // Update consent
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
      });
    }
  } else {
    disableGoogleAnalytics();
  }
};

/**
 * Check if Google Analytics should be enabled
 * This function is not used internally to avoid circular dependencies.
 * Use isCookieCategoryAllowed from cookiePreferences.js directly instead.
 */

